module.exports = __webpack_public_path__ + "static/media/down-purple.c23662bd.svg";